import { render, staticRenderFns } from "./createClaim.vue?vue&type=template&id=70c8c588&scoped=true&"
import script from "./createClaim.vue?vue&type=script&lang=js&"
export * from "./createClaim.vue?vue&type=script&lang=js&"
import style0 from "./createClaim.vue?vue&type=style&index=0&id=70c8c588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8c588",
  null
  
)

export default component.exports